import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function PageHero({ eyebrow, title, accent, subtitle, image, crumbs = [] }) {
  return (
    <section className="relative pt-40 lg:pt-56 pb-20 lg:pb-28 overflow-hidden grain">
      {image && (
        <>
          <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover kenburns" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/85 via-black/70 to-[#08080a]" />
          <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/30 to-transparent" />
        </>
      )}
      {!image && (
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0c] to-[#08080a]" />
      )}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10">
        {/* Breadcrumbs */}
        {crumbs.length > 0 && (
          <nav className="flex items-center gap-2 text-xs text-white/55 mb-6">
            <Link to="/" className="hover:text-white">Home</Link>
            {crumbs.map((c, i) => (
              <React.Fragment key={i}>
                <ChevronRight className="w-3 h-3" />
                {c.to ? (
                  <Link to={c.to} className="hover:text-white">{c.label}</Link>
                ) : (
                  <span className="text-white/75">{c.label}</span>
                )}
              </React.Fragment>
            ))}
          </nav>
        )}
        {eyebrow && (
          <div className="inline-flex items-center gap-3 px-3 py-1.5 rounded-full border border-white/15 bg-white/5 backdrop-blur text-[11px] uppercase tracking-[0.25em] text-white/85 mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-[#F5D000]" />
            {eyebrow}
          </div>
        )}
        <h1 className="font-display text-white text-4xl sm:text-5xl lg:text-7xl font-bold leading-[1.02] max-w-4xl">
          {title}
          {accent && <span className="block text-[#F5D000]">{accent}</span>}
        </h1>
        {subtitle && (
          <p className="mt-6 text-white/75 text-base sm:text-lg leading-relaxed max-w-2xl">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
